import { useLDClient } from 'launchdarkly-react-client-sdk';
import { datadogLogs } from '@datadog/browser-logs';
import { useEffect, useMemo, useState } from 'react';
import FeatureFlags from './enums';

const ERROR = 'ERROR';

export { FeatureFlags };

const useFeatureFlag = (featureFlagKey: FeatureFlags) => {
  const ldClient = useLDClient();

  // Feature flags could be configured for Cypress here, see Janus for example
  const variationDetail = useMemo(() => {
    return ldClient?.variationDetail(featureFlagKey.toString());
  }, [featureFlagKey, ldClient]);

  // Initialize with null value to allow distinguishing between unloaded and disabled flag states
  const [isActive, setIsActive] = useState(null);

  useEffect(() => {
    if (variationDetail?.reason?.kind === ERROR) {
      const logDetails = {
        data: {
          featureFlagKey,
          errorMessage: variationDetail.reason.errorKind,
          userKey: ldClient.getContext().key,
        },
      };

      datadogLogs.logger.log(
        'feature flag evaluation failed',
        logDetails,
        'error',
      );

      setIsActive(false);
    } else {
      const featureFlagValue = variationDetail?.value;
      if (featureFlagValue !== undefined) {
        setIsActive(featureFlagValue);
      }
    }
  }, [featureFlagKey, ldClient, variationDetail]);

  return isActive;
};

export default useFeatureFlag;
